import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于我们
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            了解羞羞动漫网站的故事与使命
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto text-center">
            {aboutData.desc}
          </p>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-5">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                  {stat.value}
                </div>
                <div className="mt-1.5 text-xs md:text-sm text-foreground-600">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}